import { render } from "./PendingApplicationList.vue?vue&type=template&id=552debaa&scoped=true"
import script from "./PendingApplicationList.vue?vue&type=script&lang=js"
export * from "./PendingApplicationList.vue?vue&type=script&lang=js"

import "./PendingApplicationList.vue?vue&type=style&index=0&id=552debaa&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552debaa"]])

export default __exports__